import React from "react"

function Page404() {
  return (
    <div className="page_container">
      <div class="main">
        <div class="cm_error">
          <div id="outline">
            <div id="errorboxoutline">
              <div class="cm_error-code">
                <span class="first">4</span>
                <span class="">0</span>
                <span class="last">4</span>{" "}
              </div>
              <div class="wrap-text">
                <div class="cm_error-message">
                  <h1>Oops!</h1>
                  <h2>Page not found</h2>
                </div>
                <div id="errorboxbody">
                  <p>
                    The page you are looking for might have been removed had its
                    name changed or is temporarily unavailable.
                  </p>
                </div>
                <a
                  class="button-home"
                  href="/order"
                  title="Go to the Home Page"
                >
                  Home Page
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page404
